import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import useAgentData from "@casino/legacy/client/hooks/useAgentData";

const useGameCardSize = () => {
  const { isMobile } = useAgentData();
  const thumbsRedesignEnabled = useFeature("thumbsRedesign");
  if (thumbsRedesignEnabled) {
    return isMobile ? { width: 104, height: 140 } : { width: 140, height: 188 };
  }
  return isMobile ? { width: 152, height: 212 } : { width: 218, height: 280 };
};

export default useGameCardSize;
